import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotFashionComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotFashion',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F69",
    fillRule: "evenodd",
    d: "m21.506 6.078-.01-.003c-.566-.185-.65-.21-1.217-.388-1.996-.623-3.976-1.241-5.478-1.327l-.12.09-.02-.13s-.93-.92-2.73-.89c-1.8.02-2.91.89-2.91.89h.02c-1.494.129-3.88.89-5.76 1.49l-.563.18c-.42.132-.71.522-.644.956.078.516.24 1.244.547 2.384.262.967.572 1.726.805 2.223.188.403.641.586 1.07.468l1.465-.401v9.89c0 .28.22.5.5.5h11.05c.28 0 .5-.22.5-.5v-9.89l1.789.453c.438.11.887-.091 1.05-.512.185-.479.432-1.218.681-2.261.351-1.468.45-1.925.457-2.54a.715.715 0 0 0-.482-.682Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FFA7C1",
    fillRule: "evenodd",
    d: "M13.821 13.18h1.91c.55 0 1-.45 1-1V9.01s-.85.24-1.92.24c-1.07 0-2-.24-2-.24v3.17c.01.55.46 1 1.01 1ZM15.921 4.46l-.15-.57-.28-1.08c-.02.12-.15.26-.36.36-.48.23-1.39.43-2.5.49-.22.01-.44-.01-.67-.01h.51c.05 0 .1 0 .15.01.38.07.6.39.76.8.02.06.05.12.08.18l.44 1.2c.04.12.17.19.29.15 1.04-.36 1.73-.8 1.73-1.52.01-.01 0-.01 0-.01ZM8.261 2.84l-.01-.03-.29 1.08-.15.57v.01c0 .73.7 1.18 1.78 1.54.12.04.25-.03.29-.15l.44-1.22c.02-.06.05-.12.07-.18.16-.41.39-.74.78-.8.05-.01.09-.01.14-.01h.45c-.21 0-.4.02-.6.01-1.13-.05-2.08-.25-2.56-.49-.2-.1-.33-.21-.34-.33Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FF3B88",
    fillRule: "evenodd",
    d: "M11.861 1.99c-2 0-3.62.37-3.62.83.02.12.15.25.36.35.49.24 1.37.432 2.56.492l.2.158.27 2.55c0 .14.12.26.26.26s.26-.12.26-.26l.26-2.54.19-.168c1.14-.06 2.02-.262 2.5-.492.21-.1.34-.23.36-.35v-.01c.02-.45-1.6-.82-3.6-.82Z"
  }));
};
SpotFashionComponent.displayName = 'SpotFashion';
export var SpotFashion = withProvisionalOverrideFromContext(SpotFashionComponent);
//# sourceMappingURL=index.js.map